// extracted by mini-css-extract-plugin
export default {"search":"CategoryItems_search__bX9fp","image":"CategoryItems_image__ceuMk"};